var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExpand = function SvgExpand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    fillRule: "evenodd",
    d: "M12.684 9.304a.92.92 0 0 1-1.315 0 .95.95 0 0 1 0-1.333l3.754-3.805h-2.027c-.54 0-.978-.422-.978-.943s.437-.942.977-.943h4.163l.027.003.026.002.02-.002.019-.002c.514 0 .93.45.93 1.005v4.277c0 .556-.417 1.005-.93 1.006-.514 0-.93-.45-.93-1.005V5.516zm-5.368 1.952a.92.92 0 0 1 1.315 0 .95.95 0 0 1 0 1.332l-3.754 3.805h2.027c.54.001.978.423.978.944s-.437.942-.977.942H2.742q-.014 0-.027-.002l-.026-.003-.02.002-.019.002c-.514 0-.93-.45-.93-1.005v-4.277c0-.555.417-1.005.93-1.005s.93.45.93 1.005v2.048z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExpand);
export default ForwardRef;